<template>
  <div class="wallet-page">
    <Binary/>
  </div>
</template>

<script>
import Binary from '@/views/dashboard/staking/Binary'
export default {
  components: {
    Binary
  },
  data () {
    return {
      isProcessing: false,
      isLoadingData: false
    }
  },
  computed: {
    ieoUserRefs () {
      return this.$store.getters.ieoUserRefs
    }
  },
  created () {
    this.isLoadingData = true
    // this.$store.dispatch('getUserReferral').then(rs => {
    //   setTimeout(() => {
    //     this.isLoadingData = false
    //   }, 500)
    // })
  },
  methods: {
  }
}
</script>
